import joinDefinedStringParts from "@utils/joinDefinedStringParts";

import type { TAddressBookEntry } from "../types";

const getAddressTitle = (addressItem: TAddressBookEntry, type: "locker" | "address"): string => {
  if (type === "locker") {
    return addressItem.locker?.name || "";
  }

  // type === "address"
  const { street, streetNumber, flatNo, zip, country } = addressItem;
  const streetFlatNumbers = joinDefinedStringParts([streetNumber, flatNo], " - ");
  const streetHouse = joinDefinedStringParts([street, streetFlatNumbers], " ");
  const zipCountry = joinDefinedStringParts([zip, country], " ");
  const addressTitle = joinDefinedStringParts([streetHouse, zipCountry], ", ");
  return addressTitle;
};
export default getAddressTitle;
